<template>
	<div>
		<div style="margin-top:30px;">
			<el-row>
				<el-col :span="5" v-if="devicetype!='mobile'">
					<span style="color:transparent;">1</span>
				</el-col>
				<el-col :span="1" v-if="devicetype=='mobile'">
					<span style="color:transparent;">1</span>
				</el-col>
				<el-col :span="15">
					<div class="inputBox" style="text-align:center;width:100%">
						<el-form label-width="80px" size="mini">
							<el-form-item
								v-if="i.ishidden == 'False'"
								class="inputItem col24"
								:label="i.showname"
								label-width="100px"
								v-for="(i, index) in setlist"
								:key="index"
								size="mini"
							>
							<div>
							<el-input
								v-if="i.controltype == 'text' && i.ishidden == 'False'"
								:type="i.controltype"
								v-model="i.value"
								:ref="i.colname"
								:style="devicetype=='mobile'?'width:200px':'width:300px'"
								@blur="val => checkinput(val, i)"
								@keyup.native="val => enterinput(val, i)"
								@change.native="val => text_change(val, i)"
							></el-input>
							<el-input
								v-if="i.controltype == 'text_change' && i.ishidden == 'False'"
								type="text"
								v-model="i.value"
								:ref="i.colname"
								@blur="val => addrinput(val, i)"
								@keyup.native="val => enterinput(val, i)"
								@change.native="val => text_change(val, i)"
							></el-input>
							<el-autocomplete
								:ref="i.colname"
								v-if="i.controltype == 'input_filter'"
								v-model="i.value"
								:fetch-suggestions="
									(queryString, cb) => {
										inputsuggestions(queryString, cb, i);
									}
								"
								value-key="showname"
								:trigger-on-focus="true"
								@keyup.native="val => enterinput(val, i)"
								@change.native="val => text_change(val, i)"
								@select="val => select_change(val, i)"
							></el-autocomplete>
							<!-- 地址联动 -->
							<el-select
								:ref="i.colname"
								v-model="i.value"
								filterable
								remote
								reserve-keyword
								placeholder="可输入关键词搜索"
								:remote-method="val => addrinput(val, i)"
								:loading="loading"
								v-if="i.controltype == 'addrinput' && i.ishidden == 'False'"
								@keyup.native="val => enterinput(val, i)"
								@change.native="val => text_change(val, i)"
							>
								<el-option disabled label="可输入关键词搜索" value=""></el-option>
								<el-option v-for="item in i.colsource" :key="item.showname" :label="item.showname" :value="item.showname"></el-option>
							</el-select>
							
							<el-input
								:ref="i.colname"
								v-if="i.controltype == 'text_group' && i.ishidden == 'False'"
								:type="i.controltype"
								v-model="i.value"
								class="input-with-search"
								@blur="val => checkinput(val, i)"
								@keyup.native="val => enterinput(val, i)"
								@change.native="val => text_change(val, i)"
							>
								<div slot="append" v-if="i.colass == 'search'" @click="inputgroupsearch(i, index)">
									<span style="padding:15px"><i class="el-icon-search"></i></span>
								</div>
							</el-input>
							
							<el-input
								:ref="i.colname"
								v-if="i.controltype == 'textarea' && i.ishidden == 'False'"
								:type="i.controltype"
								v-model="i.value"
								:rows="devicetype=='pc'?3:5"
								:style="devicetype=='mobile'?'width:200px':'width:300px'"
								@blur="val => checkinput(val, i)"
								@keyup.native="val => enterinput(val, i)"
								@change.native="val => text_change(val, i)"
							></el-input>
							<el-select
								:ref="i.colname"
								v-model="i.value"
								filterable
								remote
								reserve-keyword
								placeholder="可输入关键词搜索"
								:loading="loading"
								v-if="i.controltype == 'select_filter' && i.ishidden == 'False'"
								@change.native="val => text_change(val, i)"
								@keyup.native="val => enterinput(val, i)"
							>
								<el-option disabled label="可输入关键词搜索" value=""></el-option>
								<el-option v-for="item in i.colsource" :key="item.value" :label="item.title" :value="item.value"></el-option>
							</el-select>
							<el-select
								:ref="i.colname"
								v-model="i.value"
								v-if="i.controltype == 'select' && i.ishidden == 'False'"
								@keyup.native="val => enterinput(val, i)"
							>
								<el-option v-for="(opt, opti) in i.colsource" :key="opti" :value="opt.title">{{ opt.title }}</el-option>
							</el-select>
							<!-- :style="{width:`${i.coltdwidth}px`}" -->
							<el-checkbox
								v-else-if="i.controltype == 'checkbox' && i.ishidden == 'False'"
								:style="{ width: i.isEnable != undefined || i.isEnable != null ? `200px` : '' }"
								:checked="i.coldefault == 1 ? true : false"
								@change="val => setcheck(val, i)"
							></el-checkbox>
							
							<el-radio v-else-if="i.controltype == 'radio' && i.ishidden == 'False'" :style="{ width: `${i.coltdwidth}px` }"></el-radio>
						  </div>
						</el-form-item>
						</el-form>
					</div>
				</el-col>
			</el-row>
			<el-row class="footerhandler" v-if="devicetype=='mobile'" style="margin-top:50px;">
				<el-col :span="5" style="color:transparent;">1</el-col>
				<el-col :span="6" class="submitBtn"><div @click="savecrminfo">确定</div></el-col>
				<el-col :span="1" style="color:transparent;">1</el-col>
				<el-col :span="6" class="submitBtn_cancel"><div @click="reback">取消</div></el-col>
			</el-row>
			<span class="dialog-footer" v-if="devicetype!='mobile'">
				<div style="text-align:center;width:100%;padding-top:10px">
					<el-button size="mini" type="success" @click.native="savecrminfo">保存</el-button>
					<el-button size="mini" style="margin-left:10px" type="info" plain @click.native="reback">关闭</el-button>
				</div>
			</span>
		</div>
	</div>
</template>
<script>
import Utils from '../../lib/util.js';
export default {
	components: {
		
	},
	props: {
		title:{
			type: String,
			default:''
		},
		l_mode:{
			type: String,
			default:''
		}
	},
	data() {
		return{
			lang:'cn',
			setlist:[],
			crminfo:{},
			invoicetype:'',
			devicetype:this.$devicetype,
			vipaccount:'',
			crm_id:''			
		};
	},
	methods:{
		init(param){
			this.crminfo={};
			this.lang='cn';
			this.invoicetype='';
			this.vipaccount='';
			this.crm_id='';
			this.setlist=[];
			if(param.lang!=undefined)
				this.lang=param.lang;
			if(param.crminfo!=undefined)
				this.crminfo=param.crminfo;
			if(param.invoicetype!=undefined)
				this.invoicetype=param.invoicetype;
			if(param.vipaccount!=undefined)
				this.vipaccount=param.vipaccount;
			if(param.crm_id!=undefined)
				this.crm_id=param.crm_id;
				
			//debugger

			this.getsetlist();
		},
		getsetlist(){
			var that=this;
			this.$apipost.get.GetPagecolSet({syscol:'',l_mode:'开票信息-'+this.lang}).then(res => {
				if(res.length>0){
					that.setlist=res;
					if(that.crminfo!=''){
						that.setlist.forEach(item => {
							for(var i in that.crminfo){
								if(item.colname==i){
									item.value=that.crminfo[i];
								}
							}
						});
					}
				}
			});
		},
		getInfoObj(){
			var paraminfo={};
			var setlist=this.setlist;
			for(var i=0;i<setlist.length;i++){
				if(setlist[i].ishidden=='False'){
					if(setlist[i].isnull=='False'&&setlist[i].value==''){
						this.$tool.message('请填写'+setlist[i].colname, 0);
						this.paraminfo='';
						break;
					}else 
						paraminfo[setlist[i].colname]=setlist[i].value;
				}
			}
			return paraminfo;
		},
		savecrminfo(){
			var that=this;
			var info=this.getInfoObj();
			if(info!=''){
				info.vipaccount=this.vipaccount;
				info.crm_id=this.crm_id;
				var paraminfo={
					invoicetype:this.invoicetype,
					info:info
				}
				this.$apipost.post.SaveCrmExtend({paraminfo:paraminfo}).then(res => {
					if(res.state=='1')
						this.$emit('addinvoicecallback',{event:'save',paraminfo:info});
					else
						this.$tool.message(res.message, 0);
				});
			}
		},
		reback(){
			this.$emit('addinvoicecallback',{event:'cancel'});
		},
		setcheck(val, i) {
			if (val) i.value = 1;
			else i.value = 0;
		},
		checkinput(event, i) {
			if(i.colevent=='getcompany'){
				this.$apipost.get.GetCompany({keyword:i.value}).then(res => {
					if(res.state=='1'){
						//debugger
						 if (that.setlist.length > 0) {
						 	setlist.forEach(e => {
								for(var i in res.info){
									if(e.colname==i)
										e.value=res.info[i];
								}
							});
						}
					}
				});
			}
		},
		text_change(){
			
		},
		addrinput(){
			
		},
		select_change(){
			
		},
		inputsuggestions(){
			
		},
		enterinput(){
			
		}
	}
}
</script>
<style>
.footerhandler{
	position:absolute;
	bottom:30px;
}
.footerhandler .submitBtn {
	display: flex;
	justify-content: flex-end;
	text-align: center;
	height: 120rpx;
	margin-top: 5px;
	padding-bottom: 0;
}
.footerhandler .submitBtn div {
	background-color: #67c23a;
	height: 120rpx;
	border-radius: 5px;
	padding-top: 6px;
	padding-bottom: 6px;
	font-size: 15pt;
	color: #fff;
	width: 180px;
	letter-spacing: 15px;
	cursor: pointer;
}
.footerhandler .submitBtn_cancel {
	display: flex;
	justify-content: flex-end;
	text-align: center;
	height: 80rpx;
	margin-top: 5px;
	padding-bottom: 0;
}
.footerhandler .submitBtn_cancel div {
	background-color: #b6b9b3;
	height: 80rpx;
	border-radius: 5px;
	padding-top: 6px;
	padding-bottom: 6px;
	font-size: 15pt;
	color: #fff;
	width: 180px;
	cursor: pointer;
}	
.inputBox {
	display: flex;
	flex-wrap: wrap;
}
.inputBox .inputItem {
	margin-bottom: 10px;
	font-family: microsoft yahei;
}
.inputBox .col12 {
	width: 50%;
}
.inputBox .col8 {
	width: 33.333%;
}
.inputBox .col24 {
	width: 94.5%;
}
</style>
